import { ActionBar } from '../ActionBar';
import { Wrapper } from './BookingTopBar.styles';
import type { BookingTopBarProps } from './BookingTopBar.types';

export function BookingTopBar({
  onBack,
  backLabel = 'Go back',
  progressStep = 1,
  progressTotal,
  inset = true,
  desktopHidden = false,
}: BookingTopBarProps) {
  return (
    <Wrapper $inset={inset} $desktopHidden={desktopHidden}>
      <ActionBar
        onBack={onBack}
        backAriaLabel={backLabel}
        currentStep={progressStep}
        totalSteps={progressTotal}
      />
    </Wrapper>
  );
}
